
import { EmbeddingKey } from '../../types';

export const embedding: Record<EmbeddingKey, string> = {
  embedCodeCopied: 'Embed code copied',
  embedVideo: 'Embed Video',
  embedVideoDescription: 'Embed video description',
  iframeEmbedDescription: 'iFrame embed description',
  jsEmbedDescription: 'JavaScript embed description',
  copyEmbed: 'Copy embed code',
};
